import React from "react";
import { useFormContext } from "react-hook-form";
import { SelectOption } from "../../../../../types/select";
import { ReactSelectField } from "../../../../atoms/FormElement";
import { getSelectPlaceholderMessage } from "../../../../libs/form";

export const invoicingPatternOptions: SelectOption[] = [
  { label: "At beginning of lease", value: "atBeginningOfLease" },
  { label: "At each due date", value: "atEachDueDate" },
];

export const InvoicingPatternSelect = () => {
  const { control, setValue, formState } = useFormContext();

  const label = "Invoicing Pattern";
  const invoicingPatternError = formState?.errors?.invoicingPattern;

  return (
    <ReactSelectField
      isRequired
      control={control}
      setValue={setValue}
      label={label}
      fieldname="invoicingPattern"
      selectOption={invoicingPatternOptions}
      iProps={{ placeholder: getSelectPlaceholderMessage(label) }}
      validate={invoicingPatternError && "error"}
      validMessage={invoicingPatternError?.message}
    />
  );
};
